import classNames from 'classnames'
import { EyebrowMD } from '@/atoms/Text'

interface ClosedCaptionsBadgeProps {
  className?: string
}

export const ClosedCaptionsBadge = ({ className }: ClosedCaptionsBadgeProps) => {
  return <EyebrowMD className={classNames('w-fit whitespace-nowrap rounded border px-1', className)}>CC</EyebrowMD>
}
